<template>
  <div></div>
</template>
    
<script>
export default {
  name: "ViewRefundView",
  components: {},
};
</script>